module.exports = "/assets/data/d68db7f5922481d95a9942a12ed57c0f-YO19.data.json";